import { BrowserRouter, Navigate, useRoutes } from "react-router-dom";
import { MenuContextProvider } from "../Context/menuContex";

import "./App.css";
import { Home } from "../Pages/Home";
import { Menu } from "../Pages/Menu";
import "tailwindcss/tailwind.css";
import { ItemDetails } from "../Pages/ItemDetail";
import { ShoppingCart } from "../Pages/ShopingCart";

const AppRoutes = () => {
  let routes = useRoutes([
    { path: "/", element: <Home /> },
    { path: "/home", element: <Home /> },
    { path: "/menu", element: <Menu /> },
    { path: "/menu/:id", element: <ItemDetails /> },
    { path: "/shoppingcart", element: <ShoppingCart /> },
    // fallback route
    { path: "*", element: <Navigate to="/" /> },
  ]);
  return routes;
};

function App() {
  return (
    <div className=" min-w-[320px]  flex flex-col items-center">
      <MenuContextProvider>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
      </MenuContextProvider>
    </div>
  );
}

export default App;
